import * as yup from 'yup';
import { QuizCallout } from '@web/components';
import { nullableImageFromCMSSchema } from '../schemas';
import { schema as statBadgeSchema } from './stat_badge';

export const component = QuizCallout;

export const schema = yup
  .object({
    headline: yup.string(),
    subheadline: yup.string(),
    attribute: yup.string(),
    icon: nullableImageFromCMSSchema,
    badge: yup.lazy(item => {
      if (!item) return yup.mixed().notRequired();
      return statBadgeSchema;
    }),
    fontColor: yup.string(),
    backgroundColor: yup.string(),
    breedVariation: yup.string(),
  })
  .transform(value => {
    if (!value) return value;

    return {
      headline: value.headline,
      subheadline: value.subheadline,
      attribute: value.attribute,
      icon: value.icon,
      badge: value.badge?.[0] ?? undefined,
      fontColor: value.font_color || undefined,
      backgroundColor: value.background_color || undefined,
      breedVariation: value.breed_variation || undefined,
    };
  });
